import { useState, useRef } from "react";
import emailjs from "emailjs-com";

export const useSendEmail = () => {
    const form = useRef();
    const [status, setStatus] = useState(null);

    const sendEmail = (e) => {
        e.preventDefault();
        setStatus("sending");

        emailjs
            .sendForm(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                form.current,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY 
            )
            .then(
                () => {
                    setStatus("success");
                    form.current.reset();
                    setTimeout(() => setStatus(null), 5000);
                },
                () => {
                    setStatus("error");
                    setTimeout(() => setStatus(null), 5000);
                }
            );
    };

    return { form, sendEmail, status };
};
